import { render, staticRenderFns } from "./accountFlow.vue?vue&type=template&id=32826d32"
import script from "./accountFlow.vue?vue&type=script&lang=js"
export * from "./accountFlow.vue?vue&type=script&lang=js"
import style0 from "./accountFlow.vue?vue&type=style&index=0&id=32826d32&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports